import { Box, styled } from "@mui/material";

import type { ReactNode } from "react";

interface ScaledFrameProps {
  width: number;
  height: number;
  scale: number;
  children: ReactNode;
}

const Frame = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "naturalWidth" && prop !== "naturalHeight" && prop !== "scale",
})<{ naturalWidth: number; naturalHeight: number; scale: number }>(
  ({ naturalWidth, naturalHeight, scale }) => ({
    position: "relative",
    flex: "0 0 auto",
    width: naturalWidth * scale,
    height: naturalHeight * scale,
    "& > *": {
      position: "absolute",
      top: 0,
      left: 0,
      width: naturalWidth,
      height: naturalHeight,
      transformOrigin: "top left",
      transform: `scale(${scale})`,
    },
  }),
);

export function ScaledFrame({
  width,
  height,
  scale,
  children,
}: ScaledFrameProps) {
  return (
    <Frame naturalWidth={width} naturalHeight={height} scale={scale}>
      {children}
    </Frame>
  );
}
